import { Link } from 'react-router';

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-900">404</h1>
        <p className="mt-4 text-xl text-gray-600">Page not found</p>
        <p className="mt-2 text-gray-500">
          The page you&apos;re looking for doesn&apos;t exist.
        </p>
        <Link
          to="/"
          className="bg-primary-600 hover:bg-primary-700 mt-6 inline-block rounded-md px-6 py-3 text-base font-medium text-white"
        >
          Go back home
        </Link>
      </div>
    </div>
  );
}
